import { FilterLookup } from '../filters';
import CustomerLookup from './CustomerLookup';
import DriverLookup from './DriverLookup';
import LocationLookup from './LocationLookup';
import { LookupProps } from './types';

/**
 * Value input for a filter whose value is an ID looked up from the API. Only the chosen ID is saved, since that is
 * what the DispatchLeg field holds — the name is a search aid, not part of the query.
 */
export default function FilterValueLookup({ lookup, ...props }: LookupProps & { lookup: FilterLookup }) {
  switch (lookup) {
    case 'customer':
      return <CustomerLookup {...props} />;
    case 'driver':
      return <DriverLookup {...props} />;
    case 'location':
      return <LocationLookup {...props} />;
  }
}
